<script>
export default {
    name: "AttributesValidationsMixin",
    methods: {
        isRequiredClassValidation(name) {
            let required = false;
            if (this.itemsValidationsRequired?.length){
                let item = this.itemsValidationsRequired.find(i => i.name === name)
                if (item){
                    required = item.is_required;
                }
            }
           return required;
        },
    },
}
</script>

<style scoped>

</style>